/**
 * List Schema of ResponsavelConfigSms
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponsavelConfigSms} from '@/model/resource/ResponsavelConfigSms'

/* TODO: review generated schema */
export class ListResponsavelConfigSmsSchema extends Schema {
  readonly name = 'ListResponsavelConfigSms'

  readonly fieldSet: FieldSet<ResponsavelConfigSms> = {
    idConfigSmsPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    mensagem: (): FieldComponent => ({
      is: Component.Render,
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
